import React        from 'react';
import CSSModules   from 'react-css-modules';
import classNames   from 'classnames/bind';

import Input from '../Input';

import stylingUtils from '../../services/stylingUtilities';

import style from './style.scss';

function _getClassName(props) {

    const cx = classNames.bind(style);

    let baseStyle;

    switch (props) {

        case 'fixed_value':

            baseStyle = { 'price-input': true };
            break;

        case 'fixed_percentage':

            baseStyle = { 'percentage-input': true };
            break;

        default:
            break;
    }



    return cx(stylingUtils.mergeClassNames(baseStyle, props.className));
}

const getPromotionValueSection  = function (props) {

    return (
        <div>
            <div className={ style[props.fields.type.value] }>
                <Input { ...props.fields.value} className={ _getClassName(props.fields.type.value) } />
            </div>
        </div>
    );
};

export default CSSModules(getPromotionValueSection, style);


// WEBPACK FOOTER //
// ./components/PromotionValueInput/index.js